var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.121 17.897a8.764 8.764 0 0 0-1.889-2.8 8.805 8.805 0 0 0-2.8-1.89c-.01-.005-.02-.007-.029-.012A5.812 5.812 0 0 0 12 2.672a5.812 5.812 0 0 0-3.403 10.526l-.028.011a8.727 8.727 0 0 0-2.8 1.89 8.804 8.804 0 0 0-1.89 2.8 8.712 8.712 0 0 0-.691 3.237.187.187 0 0 0 .187.192h1.407a.187.187 0 0 0 .187-.183 6.988 6.988 0 0 1 2.058-4.788A6.985 6.985 0 0 1 12 14.297c1.88 0 3.645.731 4.974 2.06a6.988 6.988 0 0 1 2.058 4.788.185.185 0 0 0 .187.183h1.406a.188.188 0 0 0 .188-.192 8.734 8.734 0 0 0-.692-3.24Zm-8.12-5.381a4.005 4.005 0 0 1-2.85-1.182 4.005 4.005 0 0 1-1.182-2.85c0-1.075.42-2.088 1.181-2.85A4.005 4.005 0 0 1 12 4.454c1.076 0 2.089.419 2.85 1.18a4.005 4.005 0 0 1 1.182 2.85c0 1.076-.42 2.089-1.182 2.85A4.005 4.005 0 0 1 12 12.516Z"
  })));
};

export default SvgUser;